import thumbnail from './stackedareachart_thumb.svg';

export const metadata = {
  name: 'global.section.chartselection.stackedareachart.title',
  id: 'stackedareachart',
  thumbnail,
  icon: 'fa-chart-area',
  categories: ['categories.timeseries', 'categories.correlations'],
  description: 'global.section.chartselection.stackedareachart.description',
  code: '',
  tutorial: '',
};
